import React,{useState, useRef, useEffect} from 'react';
import DaumPostcode from "react-daum-postcode";
import { useDispatch } from 'react-redux';
import './postcode.scss'

const PostCode = ({updateAddress=null,postcode}) => {
    const detailAddressRef = useRef(null);
    const dispatch = useDispatch();
    const [isOpen, setIsOpen] = useState<boolean>(false); // 우편번호 검색 모달창
    const [address,setAddress] = useState(postcode)
    
    useEffect(() => {
        if (updateAddress !== null) {
            const payload = {
                zipcode: address.zipcode,
                roadAddress: address.roadAddress,
                detailAddress: address.detailAddress, // detailAdress 오타 수정 필요
            };
            dispatch(updateAddress(payload))
        }
    }, [address]);

    
    // 주소 선택 완료 후 호출되는 함수
    const completeHandler = (data:any) => {
        const newAddress = {...address, zipcode:data.zonecode,roadAddress:data.roadAddress,}
        setAddress(newAddress)
        dispatch(updateAddress(newAddress))
        setIsOpen(false);
    }

    useEffect(() => {
        if(detailAddressRef.current && address.zipcode !== '' && isOpen === false){
            detailAddressRef.current.focus(); // 다시 포커스 처리
        }
    }, [address.zipcode, isOpen]);

    // 상세주소 입력 시 호출되는 함수
    const changeDetailAddress = (e:React.ChangeEvent<HTMLInputElement>) => {
        const newAddress = {...address,detailAddress:e.target.value}
        setAddress(newAddress)
        if (updateAddress !== null) {
            dispatch(updateAddress(newAddress));
        }
    }

    
    return (
        <div className='address-input-wrap'>
        <div className='address-input'>
            <input
                className={`input-text input-full unfocus`}
                placeholder='도로명, 지번, 건물명 검색'
                value={address.zipcode}
                readOnly
            />
            <button className='btn btn-medium btn-gray900' onClick={() => setIsOpen(true)}>주소 찾기</button> 
        </div>
        <input
            style={{marginBottom:'12px'}}
            className={`input-text input-full unfocus`}
            value={address.roadAddress}
            placeholder='주소'
            readOnly
        />
        <input
            id='adress-detail-input'
            ref={detailAddressRef}
            type="text"
            className={`input-text input-full`}
            style={{marginBottom: '90px'}}
            placeholder='상세주소를 입력해주세요.'
            onChange={changeDetailAddress}
            value={address.detailAddress}
        />
        {isOpen && 
        <div className='postcode-modal-overlay' onClick={()=>setIsOpen(false)}>
            <div className="postcode-modal-content" onClick={e => e.stopPropagation()}>
                <DaumPostcode onComplete={completeHandler}/>
            </div> 
        </div>
        }
    </div>
    );
};

export default PostCode;